import * as luckySixTranslationsPackage from '@nsftx/i18n-lucky-six';

export default {
  name: 'luckysix',
  futureOnMultiTicketEnabled: false, // SPECIAL FLAG FOR PREMIER
  editBetModeFeatureAllowed: true,
  translationPackage: luckySixTranslationsPackage,
};
